import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';

export const ConnectionPartnersApi = {
  index() {
    return http.get(`${orgPath()}/marketplace`).then((response) => response.data);
  },
};
